import {
  VStack,
  HStack,
  View,
  Text,
  Pressable,
  Spinner,
  Center,
} from 'native-base';

import { ActivityIndicator } from 'react-native';

// Assets & Icons
import { theme } from '@breakroom-nx/assets';
import {
  LightningBoltIcon,
  ArrowDownIcon as ScrollDownIcon,
  PaperAirplaneIcon,
  PhotographIcon,
} from 'react-native-heroicons/solid';

import { LanguageIcon } from '@heroicons/react/24/solid';

// Components
import {
  UserAvatar,
  IconButton,
  PointsTag,
  Gradient,
  SecondaryButton,
} from '../../';

// Classes & Types
import { Flair } from '@breakroom-nx/classes';

import {
  Avatar,
  Bubble,
  SystemMessage,
  Message as GiftedChatMessage,
  MessageText,
  InputToolbar,
  Actions,
  Composer,
  IMessage,
  Send,
  Time,
  Day,
  QuickReplies,
  InputToolbarProps,
  isSameDay,
  LoadEarlier,
} from 'react-native-gifted-chat';

import { getAuth } from 'firebase/auth';
import { timeFrom } from '@breakroom-nx/helpers';

// Utility function to check if message is from the client (logged-in user)
// TODO: - Refactor for redux/actual logic
const isClient = (message: any) => {
  const auth = getAuth();
  const clientUID = auth.currentUser!.uid;
  return message.user._id === clientUID;
};

const isAnonymous = () => {
  const auth = getAuth();
  const isAnonymous = auth.currentUser?.isAnonymous;
  return isAnonymous;
};

// Utility function to check if previous message is from the same user.
const isSameUser = (firstMessage: any, secondMessage: any) => {
  if (firstMessage.user && secondMessage.user) {
    return (
      firstMessage.user._id == secondMessage.user._id &&
      firstMessage.user.name == secondMessage.user.name
    );
  }
  return false;
};

export const renderBubble = (props: any) => {
  const { onTranslate, translatingMessageId } = props;
  const flair: Flair = props.currentMessage.user.flair;
  // const isTranslating = translatingMessageId === props.currentMessage._id;
  const isTranslating = false;

  // console.log(
  //   `IS TRANSLATING: ${translatingMessageId} | CURRENT MESSAGE ID: ${props.currentMessage._id} | CURRENT MESSAGE ${props.currentMessage.text}`
  // );
  // console.log(`Bubble Props: ${props.currentMessage.user.name}`);

  return (
    <VStack
      maxW={'70%'}
      marginLeft={0}
      space={1}
      alignItems={isClient(props.currentMessage) ? 'flex-end' : 'flex-start'}
    >
      {!isSameUser(props.currentMessage, props.previousMessage) &&
      !isClient(props.currentMessage) ? (
        <Pressable onPress={null}>
          <HStack alignItems={'center'} space={3} mb={1} mt={2}>
            <Text
              fontSize={15}
              fontWeight={600}
              fontFamily={'Poppins-Bold'}
              color={flair ? flair.getColor() : theme.colors.yellow[200]}
            >
              {props.currentMessage.user.name}
            </Text>
            {/* IDEA: - Flair next to username */}
            {/* {flair ? <Box>{flair.getIcon(13)}</Box> : null} */}
            <span
              className={`fi fi-${props.currentMessage.user.geoCode}`}
              style={{ height: '10px', width: '14px' }}
            ></span>
          </HStack>
        </Pressable>
      ) : null}

      <HStack alignItems={'end'} width={'auto'}>
        <Bubble
          {...props}
          renderUsernameOnMessage={false}
          renderTime={() => {}}
          renderTicks={() => {}}
          containerStyle={{}}
          wrapperStyle={{
            left: {
              paddingTop: 10,
              paddingBottom: 8,
              paddingHorizontal: 20,
              backgroundColor: theme.colors.surface[200],
              borderRadius: 20,
              // Stupid, but the Gifted Chat has css margins built in, have to override.
              marginRight: 0,
            },
            right: {
              paddingTop: 10,
              paddingBottom: 8,
              paddingHorizontal: 20,
              backgroundColor: theme.colors.primary[300],
              // Stupid, but the Gifted Chat has css margins built in, have to override.
              borderRadius: 20,
              // Stupid, but the Gifted Chat has css margins built in, have to override.
              marginLeft: 0,
            },
          }}
          bottomContainerStyle={{
            left: {},
            right: {},
          }}
          tickStyle={{
            color: 'white',
          }}
          usernameStyle={{
            fontSize: 13,
            color: flair ? flair.getColor() : 'white',
          }}
          containerToNextStyle={{
            left: {},
            right: {},
          }}
          containerToPreviousStyle={{
            left: {},
            right: {},
          }}
        />
        {!isClient(props.currentMessage) &&
          (isTranslating ? (
            <Spinner size="sm" color={theme.colors.primary[400]} ml={2} />
          ) : (
            <IconButton
              icon={
                <LanguageIcon
                  color={theme.colors.surface[700]}
                  width={'12px'}
                  height={'12px'}
                />
              }
              tooltipText="Translate"
              onPress={() => onTranslate && onTranslate(props.currentMessage)}
            />
          ))}
      </HStack>
      {!isSameUser(props.currentMessage, props.nextMessage) && (
        <Text
          fontSize={13}
          fontWeight={300}
          fontFamily={'Poppins-Medium'}
          color={theme.colors.surface[500]}
        >
          {timeFrom(new Date(props.currentMessage.createdAt), true)}
        </Text>
      )}
    </VStack>
  );
};

export const renderBubbleOnMap = (props: any) => {
  const flair: Flair = props.currentMessage.user.flair;

  // console.log(`Message: ${props.currentMessage.user.name}`);

  return (
    <VStack maxW={'80%'} space={'1px'} alignItems={'flex-start'}>
      {/* Custom username view */}
      {!isSameUser(props.currentMessage, props.previousMessage) &&
      !isClient(props.currentMessage) ? (
        <Pressable onPress={null}>
          <HStack alignItems={'center'} space={'2px'}>
            <Text
              fontSize={14}
              fontWeight={500}
              color={flair ? flair.getColor() : theme.colors.surface[400]}
              ml={1}
            >
              {props.currentMessage.user.name}
            </Text>
            {/* IDEA: - Flair next to username */}
            {/* {flair ? <Box>{flair.getIcon(13)}</Box> : null} */}
          </HStack>
        </Pressable>
      ) : null}
      <Bubble
        {...props}
        renderUsernameOnMessage={false}
        renderTime={() => {
          return null;
          // return renderTime(props);
        }}
        renderTicks={() => {}}
        containerStyle={{
          left: {},
          right: {},
        }}
        wrapperStyle={{
          left: {
            paddingTop: 2,
            paddingBottom: 0,
            paddingLeft: 1,
            paddingRight: 1,
            backgroundColor: theme.colors.primary[100],
            borderRadius: 18,
          },
          right: {
            paddingTop: 2,
            paddingBottom: 1,
            paddingLeft: 1,
            paddingRight: 1,
            backgroundColor: theme.colors.primary[300],
            borderRadius: 18,
          },
        }}
        bottomContainerStyle={{
          left: {
            paddingTop: 3,
          },
          right: {},
        }}
        tickStyle={{
          color: 'white',
        }}
        usernameStyle={{
          fontSize: 13,
          fontFamily: 'Poppins',
          color: flair ? flair.getColor() : theme.colors.surface[400],
        }}
        containerToNextStyle={{
          left: {},
          right: {},
        }}
        containerToPreviousStyle={{
          left: {},
          right: {},
        }}
      />
    </VStack>
  );
};

export const renderDay = (props: any) => {
  // Object.keys(props).forEach((prop) => console.log(prop));

  if (props.previousMessage) {
    if (!isSameDay(props.currentMessage, props.previousMessage)) {
      return (
        <Day
          {...props}
          textStyle={{
            fontFamily: 'Poppins-Regular',
            fontSize: 13,
            color: theme.colors.surface[400],
          }}
        />
      );
    }
  }

  // const ageDifMs = Date.now() - props.currentMessage.createdAt.seconds;
  // const ageDate = new Date(ageDifMs);
  // console.log(`Date of Message: ${ageDate.toString()}`);

  // return (
  //   <Text
  //     fontWeight={300}
  //     color={'surface.400'}
  //     fontSize={13}
  //     textAlign={'center'}
  //   >
  //     {timeFrom(new Date(ageDate), false)}
  //   </Text>
  // );
};

export const renderLoading = () => {
  return <Spinner color={theme.colors.primary[400]} />;
};

export const renderSystemMessage = (props: any) => {
  const systemMessage = props.currentMessage.text.split(' ');
  const username = systemMessage[0];
  const message = systemMessage.slice(1).join(' ');

  return (
    <VStack alignItems={'center'} my={5}>
      <HStack
        alignItems={'center'}
        space={1}
        py={1}
        px={'10px'}
        maxW={'80%'}
        bg={'rgba(255, 255, 255, 0.06)'}
        borderRadius={'7px'}
        textAlign={'center'}
      >
        <Text
          fontWeight={200}
          color={'surface.600'}
          fontFamily={'Poppins-Regular'}
          fontSize={16}
        >
          <Text color={'primary.400'}>{username}</Text>
          {` ${message}`}
        </Text>
      </HStack>
    </VStack>
  );
};

export const renderMessageText = (props: any) => (
  <MessageText
    {...props}
    textStyle={{
      left: {
        color: 'white',
      },
      right: {
        color: 'black',
      },
    }}
    linkStyle={{
      left: {
        color: theme.colors.red[200],
        textDecorationLine: 'underline',
        fontWeight: 'bold',
      },
      right: {
        color: theme.colors.red[200],
        textDecorationLine: 'underline',
        fontWeight: 'bold',
      },
    }}
    customTextStyle={{
      fontFamily: 'Poppins-Regular',
      fontSize: 16,
      lineHeight: 23,
      lineBreak: 'strict',
      overflowWrap: 'anywhere',
      hyphens: 'auto',
    }}
  />
);

export const renderMessageTextOnMap = (props: any) => (
  <MessageText
    {...props}
    containerStyle={{
      left: {},
      right: {},
    }}
    textStyle={{
      left: {
        color: 'white',
      },
      right: {
        color: 'white',
      },
    }}
    linkStyle={{
      left: {
        color: theme.colors.primary[400],
        textDecorationLine: 'none',
      },
      right: {
        color: theme.colors.surface[200],
        textDecorationLine: 'none',
      },
    }}
    customTextStyle={{
      fontFamily: 'SF-Pro-Display-Medium',
      fontSize: 15,
      lineHeight: 21,
    }}
  />
);

export const renderInputToolbar = (props: any) => {
  if (props.hidden) {
    return null;
  } else {
    return (
      <InputToolbar
        {...props}
        containerStyle={{
          backgroundColor: theme.colors.surface[100],
          paddingVertical: 10,
          paddingHorizontal: 20,
          borderTopColor: theme.colors.surface[400],
        }}
      />
    );
  }
};

export const renderActions = (props: any) => (
  <Actions
    {...props}
    containerStyle={{
      width: 44,
      height: 44,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: 4,
      marginRight: 4,
      marginBottom: 0,
    }}
    icon={() => (
      <IconButton
        icon={<PhotographIcon size={25} color={theme.colors.primary[400]} />}
        tooltipText={'Select a Photo'}
      />
    )}
    options={{
      'Choose From Library': () => {
        // console.log('Choose From Library');
      },
      Cancel: () => {
        // console.log('Cancel');
      },
    }}
    optionTintColor="#222B45"
  />
);

export const renderComposer = (props: any) => (
  <Composer
    {...props}
    // multiline={true}
    // composerHeight={50}
    disableComposer={props.sending}
    textInputStyle={{
      color: props.sending ? theme.colors.surface[600] : '#FFF',
      display: 'flex',
    }}
  />
);

export const renderAvatar = (props: any) => {
  const flair: Flair = props.currentMessage.user.flair;

  return (
    <UserAvatar
      noMargin
      noBorder
      uid={props.currentMessage.user._id}
      avatarURL={props.currentMessage.user.avatar}
      theme={props.currentMessage.user.theme}
      flair={flair}
      size={9}
    />
  );
};

export const renderLoadEarlier = (props: any) => {
  if (props.isLoadingEarlier) {
    return (
      <ActivityIndicator
        animating={true}
        color={theme.colors.surface[400]}
        hidesWhenStopped={true}
      />
    );
  } else {
    return (
      <SecondaryButton
        bg={'none'}
        fontSize={14}
        py={2}
        color={theme.colors.surface[600]}
        text={props.label || 'Load Earlier Messages'}
        onPress={props.onLoadEarlier}
        disabled={props.isLoadingEarlier || !props.onLoadEarlier}
        style={{
          marginVertical: 10,
          alignSelf: 'center',
          minWidth: 140,
          borderWidth: 1,
          borderColor: theme.colors.surface[400],
        }}
      />
    );
  }
};

export const renderSend = (props: any) => (
  <Send
    {...props}
    disabled={!props.text || props.sending}
    containerStyle={{
      width: 44,
      height: 44,
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: 4,
      backgroundColor: 'blue.100',
    }}
  >
    {props.sending ? (
      <Spinner color={theme.colors.primary[400]} />
    ) : (
      <VStack alignItems={'center'}>
        <View mb={3}>
          <IconButton
            icon={
              <PaperAirplaneIcon
                size={'20px'}
                color={theme.colors.primary[400]}
                style={{
                  transform: [{ rotate: '45deg' }],
                }}
              />
            }
            onPress={() => {
              const { text, messageIdGenerator, user, onSend } = props;
              if (text && onSend) {
                onSend(
                  { text: text.trim(), user: user, _id: messageIdGenerator() },
                  true
                );
              }
            }}
            tooltipText={'Send Message'}
          />
        </View>
        {!isAnonymous() && (
          <View position={'absolute'} bottom={0.5}>
            <PointsTag amount={25} payment={true} fontSize={11} imageSize={3} />
          </View>
        )}
      </VStack>
    )}
  </Send>
);

export const scrollToBottomComponent = () => {
  return <ScrollDownIcon size={15} color={theme.colors.primary[300]} />;
};
